import { useMemo } from 'react'

import { clsx } from 'clsx'

import { Event } from '@tribeplatform/gql-client/types'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { dayjs } from '../../../../common/lib/dayjs.js'
import { hasRegisteredForEvent } from '../../../EventDetails/utils.js'

interface Props {
  highlighted?: boolean
  event: Event
  textOnly?: boolean
}

export const EventFieldRsvp = ({
  highlighted,
  event,
  textOnly = false,
}: Props) => {
  const isRegistered = hasRegisteredForEvent(event)
  const atCapacity =
    !!event?.capacity && event?.registrationsCount >= event?.capacity
  const completed = dayjs(event?.endTime).isBefore(dayjs())
  const { $t } = useI18n()

  const text = useMemo(() => {
    if (completed) {
      return $t({
        defaultMessage: 'Event ended',
        id: 'Event.ActionButtons.Ended.Button',
      })
    }
    if (isRegistered) {
      return $t({
        defaultMessage: 'Registered',
        id: 'Generics.Registered',
      })
    }
    if (atCapacity) {
      return $t({
        defaultMessage: 'At capacity',
        id: 'Event.ActionButtons.HasReachedCapacity.Button',
      })
    }
    return $t({
      defaultMessage: 'Join now',
      id: 'Event.ActionButtons.JoinNow.Button',
    })
  }, [isRegistered, atCapacity, completed, $t])

  return (
    <div
      className={clsx(
        'truncate',
        highlighted &&
          'ring-2 rounded-sm ring-offset-surface ring-focused min-w-0',
      )}
    >
      {textOnly ? (
        text
      ) : (
        <Button
          disabled={completed || atCapacity}
          variant="secondaryNeutral"
          size="lg"
          fullWidth
          truncate
        >
          {text}
        </Button>
      )}
    </div>
  )
}
